import {AxiosResponse} from 'axios';
import {axiosInstance} from '../../..';

export function getProductsCategory(): Promise<AxiosResponse<any, any>> {
    return axiosInstance.get(`ProductCategory`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
}

export function getProductCategoryId(id: string): Promise<AxiosResponse<any, any>> {
    return axiosInstance.get(`ProductCategory/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
}

export function createProductCategory(data: any): Promise<AxiosResponse<any, any>> {
    return axiosInstance.post('ProductCategory', data, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
}

export function updateProductCategoryId(id: string, data: any): Promise<AxiosResponse<any, any>> {
    return axiosInstance.put(`ProductCategory/${id}`, data, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
}
export function deleteProductCategoryId(id: string): Promise<AxiosResponse<any, any>> {
    return axiosInstance.delete(`ProductCategory/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
}
